/* unplugin-vue-components disabled */import { render } from "./ScrollShadow.vue?vue&type=template&id=6b60f404"
import script from "./ScrollShadow.vue?vue&type=script&lang=js"
export * from "./ScrollShadow.vue?vue&type=script&lang=js"

import "./ScrollShadow.vue?vue&type=style&index=0&id=6b60f404&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__